import Sidebar from '../components/Sidebar';

export default class StaticPage {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.sidebarEl = this.el.querySelector('[data-sidebar]');

    this.sidebar = new Sidebar(this.sidebarEl);
  }

  onSectionUnload() {
    this.sidebar.unload();
  }
}
